export const VERSION: string = '__VF_VERSION__';
export const ID: string = '__VF_GIT_COMMIT_ID__';
export const DATE: string = '__VF_BUILD_DATE__';
